import React, { FC, memo, useCallback, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, Link } from 'react-router-dom';
import { getDashboardSearchString } from '@hkm/components/TaskManagement/Dashboard/domain/selectors';
import { TaskDashboardItemWithFlag } from '@hkm/components/TaskManagement/domain/interfaces/taskDashboardItemWithFlag';
import { getDetails } from '@hkm/components/TaskManagement/utils/taskDetails';
import APP_ROUTES from '@hkm/constants/routing.constants';
import TaskOverview from 'src/components/TaskManagement/shared/components/TaskOverview/TaskOverview';

import { AcBadge } from '@ac/mobile-components/dist/components/badge';
import { AcFlex } from '@ac/mobile-components/dist/components/flex';
import { AcTileShell } from '@ac/mobile-components/dist/components/tile';
import { Color, TextSize } from '@ac/mobile-components/dist/enums';

import './DashboardItem.css';

interface ComponentProps {
  task: TaskDashboardItemWithFlag;
  index: number;
}

const DashboardItem: FC<ComponentProps> = props => {
  const { task, index } = props;
  const dataTestSelector = `task-management-dashboard-item-${index}`;
  const searchValue = useSelector(getDashboardSearchString);
  const actionsButtonRef = useRef<HTMLDivElement>(null);

  const taskAdditionalInfo = useMemo(() => {
    const [, searchDetails] = getDetails(searchValue, task.objectInfo);

    return searchDetails;
  }, [searchValue, task.objectInfo]);

  const onTaskTap = useCallback((e: React.MouseEvent) => {
    if (actionsButtonRef.current?.contains(e.target as Node)) {
      e.preventDefault();
    }
  }, []);

  return (
    <AcTileShell
      className="task-dashboard-item"
      testSelector={dataTestSelector}
    >
      <Link
        className="unstyled-link"
        to={generatePath(APP_ROUTES.TASK_MANAGEMENT.TASK_PREVIEW, {
          taskId: task.id
        })}
        onClick={onTaskTap}
      >
        <TaskOverview
          task={props.task}
          index={props.index}
          dashboardView={true}
          actionsButtonRef={actionsButtonRef}
        />
        {searchValue && taskAdditionalInfo && (
          <AcFlex className="ac-spacing-top-sm">
            <AcBadge
              badgeText={taskAdditionalInfo}
              badgeTextSize={TextSize.Main2}
              backgroundColor={Color.Gray4}
              testSelector={`task-dashboard-item-additional-info-${index}`}
            />
          </AcFlex>
        )}
      </Link>
    </AcTileShell>
  );
};

export default memo(DashboardItem);



// WEBPACK FOOTER //
// ./src/components/TaskManagement/Dashboard/DashboardItem/DashboardItem.tsx